/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_P3_BodyInputs */

const es_cap_p3_body = /** @type {(inputs: Cap_P3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada propuesta es tuya para aceptar o rechazar. Ves el barco, la fecha y lo que cobras antes de decir que sí.`)
};

const gl_cap_p3_body = /** @type {(inputs: Cap_P3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada proposta é túa para aceptar ou rexeitar. Vés o barco, a data e o que cobras antes de dicir que si.`)
};

const en_cap_p3_body = /** @type {(inputs: Cap_P3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every proposal is yours to accept or decline. You see the boat, date, and pay before you say yes.`)
};

/**
* | output |
* | --- |
* | "Every proposal is yours to accept or decline. You see the boat, date, and pay before you say yes." |
*
* @param {Cap_P3_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_p3_body = /** @type {((inputs?: Cap_P3_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_P3_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_p3_body(inputs)
	if (locale === "en") return en_cap_p3_body(inputs)
	return es_cap_p3_body(inputs)
});